var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg003Hexagonal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375,199V71c0-5.5-3-10.6-7.9-13.2l-104-56c-4.4-2.4-9.8-2.4-14.2,0l-104,56C140,60.4,137,65.5,137,71v128 c0,5.5,3,10.6,7.9,13.2l104,56c2.2,1.2,4.7,1.8,7.1,1.8c2.4,0,4.9-0.6,7.1-1.8l104-56C372,209.6,375,204.5,375,199z M345,190 l-89,48l-89-48V80l89-48l89,48V190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.1,299.8l-104-56c-4.4-2.4-9.8-2.4-14.2,0l-104,56C3,302.4,0,307.5,0,313v128c0,5.5,3,10.6,7.9,13.2 l104,56c2.2,1.2,4.7,1.8,7.1,1.8s4.9-0.6,7.1-1.8l104-56c4.9-2.6,7.9-7.7,7.9-13.2V313C238,307.5,235,302.4,230.1,299.8z M208,432 l-89,48l-89-48V322l89-47.9l89,47.9V432z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.1,299.8l-104-56c-4.4-2.4-9.8-2.4-14.2,0l-104,56c-4.9,2.6-7.9,7.7-7.9,13.2v128c0,5.5,3,10.6,7.9,13.2 l104,56c2.2,1.2,4.7,1.8,7.1,1.8s4.9-0.6,7.1-1.8l104-56c4.9-2.6,7.9-7.7,7.9-13.2V313C512,307.5,509,302.4,504.1,299.8z M482,432 l-89,48l-89-48V322l89-47.9l89,47.9V432z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg003Hexagonal);
export default __webpack_public_path__ + "static/media/003-hexagonal.bfc4c095c494c72875fd0caa92671bc6.svg";
export { ForwardRef as ReactComponent };